import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl=process.env.REACT_APP_API_URL;


 async function doNewCustomerAccount(payload){

    const result= await axios.post(apiUrl + "/signup" ,payload,{

        headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}

async function doNewAdminAccount(payload){

    const result= await axios.post(apiUrl + "/admin/signup",payload,{

        headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
async function getSubBrokers(payload){

    const result= await axios.post(apiUrl + "/admin/dropdown/getsubbrokers",payload,{

        headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}

async function getCustomer(payload){

    const result= await axios.post(apiUrl + "/admin/getusers",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
async function getBrokers(payload){

    const result= await axios.post(apiUrl + "/admin/dropdown/getbrokers",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}

async function getMaster(payload){

    const result= await axios.post(apiUrl + "/admin/dropdown/getmasters",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
async function updateAdmin(payload){

    const result= await axios.post(apiUrl + "/admin/edit",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
async function updateCustomer(payload){

    const result= await axios.post(apiUrl + "/edit",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
async function updateCustomerData(payload){

    const result= await axios.post(apiUrl + "/update",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
async function updateAdminData(payload){

    const result= await axios.post(apiUrl + "/admin/update",payload,{

         headers: jsonHeader}
    ).catch((error) => {
    
    return error.response.data || [];

});
return result.data || [];
}
export const signupservices = {
    doNewCustomerAccount,
    doNewAdminAccount,
    getSubBrokers,
    getCustomer,
    getMaster,
    getBrokers,
    updateAdmin,
    updateCustomer,
    updateCustomerData,
    updateAdminData
}